import React, { useEffect, useRef, useState } from 'react';
import './ReelsSection.css';

const REELS = [
  { id: 1, src: '/reel1.mp4' },
  { id: 2, src: '/reel2.mp4' },
  { id: 3, src: '/reel3.mp4' },
];

const MuteIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M11 5L6 9H3v6h3l5 4V5z" />
    <path d="M23 9l-6 6" />
    <path d="M17 9l6 6" />
  </svg>
);

const SoundIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M11 5L6 9H3v6h3l5 4V5z" />
    <path d="M15.5 8.5a5 5 0 0 1 0 7" />
    <path d="M18.5 5.5a9 9 0 0 1 0 13" />
  </svg>
);

const ReelsSection = () => {
  const sectionRef = useRef(null);
  const videoRefs = useRef([]);
  const [activeIndex, setActiveIndex] = useState(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return;

    const observer = new IntersectionObserver(
      ([entry]) => setIsVisible(entry.isIntersecting),
      { threshold: 0.3 }
    );

    observer.observe(section);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    videoRefs.current.forEach((video) => {
      if (!video) return;

      if (isVisible) {
        video.play()?.catch(() => {});
      } else {
        video.pause();
      }
    });
  }, [isVisible]);

  useEffect(() => {
    videoRefs.current.forEach((video, index) => {
      if (!video) return;
      video.muted = activeIndex !== index;
    });
  }, [activeIndex]);

  const handleSoundToggle = (index) => {
    setActiveIndex((prev) => (prev === index ? null : index));
  };

  return (
    <section ref={sectionRef} className="reels_section" aria-label="InstaSnap Reels">
      <div className="reels_container">
        <header className="reels_header">
          <h2 className="reels_title">Reels</h2>
          <p className="reels_subtitle">Moments from the booth</p>
        </header>

        <div className="reels_grid">
          {REELS.map((reel, index) => {
            const isActive = activeIndex === index;

            return (
              <article
                key={reel.id}
                className={`reels_card ${isActive ? 'is_active' : ''}`}
                style={{ '--delay': `${index * 0.1}s` }}
              >
                <button
                  type="button"
                  className="reels_card_button"
                  onClick={() => handleSoundToggle(index)}
                  aria-label={isActive ? 'Mute reel' : 'Unmute reel'}
                >
                  <div className="reels_frame">
                    <video
                      ref={(el) => {
                        videoRefs.current[index] = el;
                      }}
                      className="reels_video"
                      src={reel.src}
                      loop
                      muted
                      playsInline
                      preload="metadata"
                    />
                    <span className={`reels_sound ${isActive ? 'is_on' : ''}`}>
                      {isActive ? <SoundIcon /> : <MuteIcon />}
                    </span>
                  </div>
                </button>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ReelsSection;
